import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { Label } from '../Label'
import { Backgrounds, Corners, Paddings } from '../Label.h'

export interface ILabelSecondaryRoundedTemplateProps extends ILabelProps {}

export const LabelSecondaryRoundedTemplate = ({
  title = '',
  background = Backgrounds.SURFACE_OPACITY_LIGHT_10,
  corners = Corners.CORNERS_30,
  padding = Paddings.SIZE_20,
  ...rest
}: ILabelSecondaryRoundedTemplateProps): JSX.Element => (
  <Label
    title={title}
    background={background}
    corners={corners}
    padding={padding}
    {...rest}
  />
)
